import React, { Component } from 'react';
import _ from 'lodash';

import PouchInput from 'components/PouchInput';
import PouchColorPicker from 'components/PouchColorPicker';

class DisplayConfig extends Component {

  cleanURLString = (url) => {
    const parts = _.split(url, '?');
    return _.last(parts);
  }

  render() {
    const { meet } = this.props;
    return (
      <div className="entry-config">
        <div className="registration-title">View Configuration</div>
        <div className="entry-row">
          <label>Display Image URL:</label>
          <div className="input-wrapper">
            <PouchInput
              type='text'
              meetId={meet._id}
              documentId={meet._id}
              name='displayBackgroundImageUrl'
              value={_.get(meet, 'displayBackgroundImageUrl')}
              placeholder="https://example.com/image.png"
            />
          </div>
        </div>
        <div className="entry-row">
          <label>Display Font Color:</label>
          <div className="input-wrapper">
            <PouchColorPicker
              meet={meet}
              document={meet}
              name="displayFontColor"
              value={_.get(meet, 'displayFontColor')}
            />
          </div>
        </div>
        <div className="entry-row">
          <label>Display Background Color:</label>
          <div className="input-wrapper">
            <PouchColorPicker
              meet={meet}
              document={meet}
              name="displayBackgroundColor"
              value={_.get(meet, 'displayBackgroundColor')}
            />
          </div>
        </div>
        <div className="entry-row">
          <label>Display Default View URL:</label>
          <div className="input-wrapper">
            <PouchInput
              type='text'
              meetId={meet._id}
              documentId={meet._id}
              name='displayDefaultURL'
              value={_.get(meet, 'displayDefaultURL')}
              beforeSave={this.cleanURLString}
            />
          </div>
        </div>
        <div className="entry-row">
          <label>Board Default View URL:</label>
          <div className="input-wrapper">
            <PouchInput
              type='text'
              meetId={meet._id}
              documentId={meet._id}
              name='boardDefaultURL'
              value={_.get(meet, 'boardDefaultURL')}
              beforeSave={this.cleanURLString}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default DisplayConfig;
